import { createIcon } from '@chakra-ui/react';

export const MbeRightArrow = createIcon({
  displayName: 'MbeRightArrow',
  viewBox: '0 0 69 68',
  path: (
    <g fill="none" fillRule="evenodd">
      <path d="M.778 68h68V0h-68z" fill="#E2001A" />
      <path
        d="M31.551 43.902a1.13 1.13 0 0 1-1.59 0l-1.062-1.062a1.13 1.13 0 0 1 0-1.59L36.115 34l-7.216-7.252a1.13 1.13 0 0 1 0-1.59l1.061-1.062a1.13 1.13 0 0 1 1.591 0l9.109 9.109a1.126 1.126 0 0 1 0 1.588l-9.109 9.109z"
        fill="#FFF"
      />
    </g>
  ),
});
